import * as React from 'react';
import { Grid, MenuItem, TextField } from '@mui/material';
import { Button, Chip, Text, ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value: string;
  size?: textsize;
  box?: boolean;
  color?: any;
  options: any;
  buttonStyle?: boolean;
  readOnly?: boolean;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
}

export const InputSelect: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    props.onChange?.(props.name, e?.target.value);
  }

  const onClick = (value: string) => (e: React.MouseEvent<HTMLButtonElement>) => {
    props.onChange?.(props.name, value);
  }
  
  const getCaption = () => {
    return props.options.filter((d: any) => d.name === props.value)?.[0]?.caption || '';
  }

  return (
    <>
    {props.readOnly?
      <>
      <Text label={props.label} size='small' color='text.secondary' marginTop={2} />
      <Chip label={getCaption()} type='primary'  sx={{mt:1, mb: 2}}/> 
      </>
    :
    (props.buttonStyle || props.options.length<=3)?
      <>
      <Text label={props.label} size='small' color='text.secondary' marginTop={2} />
      <Grid marginTop={1} marginBottom={2}>
        {props.options.map((d: any, i: number) => (
          <Button key={i} label={d.caption} type={props.value === d.name? 'contained' : 'outlined'} color='primary' textTransform='capitalize' sx={{marginRight: 0.5}} onClick={onClick(d.name)}/>
        ))}
      </Grid>
      <Text label={props.error} size='small' color='red' marginBottom={2}/>
      </>
    :
      <TextField
        id={props.id || props.name}
        name={props.name}
        label={props.label}
        value={props.readOnly? getCaption() : (props.value || '')}
        placeholder={props.placeHolder}
        inputProps={{spellCheck: false}}
        InputProps={{
          readOnly: props.readOnly || false,
          sx: {fontSize: fontSize(), bgcolor: props.color, borderRadius: 3, marginTop: props.box? 1.5 : 0}
        }}
        InputLabelProps={{
          shrink: true,
          sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
        }}
        FormHelperTextProps={{
          sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
        }}
        sx = {{
          '& legend': {width: props.box? 0 : undefined},
          '& .MuiSvgIcon-root': {color: 'primary.main'},
        }}
        select={!props.readOnly}
        margin={props.disableMargin? 'none' : 'normal'}
        variant={props.box? undefined : 'standard'}
        fullWidth
        helperText={props.error}
        error= {props.error? true: false}
        onChange={onChange}
      >
        {props.options.map((d: any, i: number) => (
          <MenuItem key={i} value={d.name} sx={{fontSize: fontSize()}}>
            {d.caption}
          </MenuItem>
        ))}
      </TextField>
    }
    </>
  )
}